/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";

import { useParams } from "react-router-dom";
import {
  cardBySubCollectionsSlug,
  cardBySubCollectionsSlugByIdActive,
  swapPurchaseCardsService,
  //   cardBySubCollectionsSlugById,
  swapCardsService,
} from "../../services/cardService";
import { MoonLoader } from "react-spinners";

// import { Button } from "react-bootstrap";

// import useSwapItem from "../../hooks/useSwapItem";
// import ForSale from "./ForSale";
// import ForSwap from "./ForSwap";
import ForSwapActive from "./ForSwapActive";
import ForSaleActive from "./ForSaleActive";
import ForSwapPurchaseActive from "./ForSwapPurchaseActive";
const SingleActiveCollection = () => {
  const [isSwap, setIsSwap] = useState({
    isSwap: false,
    isAvailable: true,
    isSale: false,
  });

  // const navigate = useNavigate();
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [swapData, setSwapData] = useState([]);
  const [swapDataPurchase, setswapDataPurchase] = useState([]);
  const [url, setUrl] = useState("");
  const [, setUserId] = useState("");
  const [singleData, setSingleData] = useState({});
  const [loader, setLoader] = useState(false);
  // const { isLogin } = useContext(rootContext);
  const [isLogin, setIsLogin] = useState(false);
  // const { addToSwapCart} = useSwapItem();

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      setIsLogin(true);
      let user = JSON.parse(localStorage.getItem("user"));
      setUserId(user.id);
    }
  }, []);
  const allSubCollectionsData = async (name) => {
    setLoader(true);
    // let user = JSON.parse(localStorage.getItem("user"));
    const token = localStorage.getItem("token");
    let result = "";
    if (!token) {
      result = await cardBySubCollectionsSlug(name);
    } else {
      result = await cardBySubCollectionsSlugByIdActive(name);
    }
    if (result.card) {
      setData(result.card);
      setLoader(false);
      setUrl(result.imagePath);
    } else {
      setLoader(false);
    }
  };
  // console.log(
  //   data?.[0]?.card_collection_sub_title?.slug || "",
  //   data?.[0]?.chapter?.slug,
  //   data?.[0].card_collection_title?.slug || "",
  //   "data"
  // );
  useEffect(() => {
    const token = localStorage.getItem("token");
    allSubCollectionsData(id);
    if (token) {
      handleSwapData(id);
    }
  }, [id]);
  const HandleGetPurchaseData = () => {
    handleSwapPurchaseData(
      data?.[0]?.card_collection_sub_title?.slug || "",
      data?.[0]?.chapter?.slug,
      data?.[0].card_collection_title?.slug || ""
    );
  };

  // const handleCartImage=(item)=>{
  //  const result =addToSwapCart(item);
  //   if(result){

  //      navigate('/select-swaps-card');
  //   }
  // }

  const handleSwapData = async (name) => {
    setLoader(true);
    let user = JSON.parse(localStorage.getItem("user"));

    let result = await swapCardsService(name, user.id);
    if (result) {
      setSwapData(result);

      setLoader(false);
    } else {
      setLoader(false);
    }
  };
  const handleSwapPurchaseData = async (subtitle, chapter, title) => {
    setLoader(true);

    let result = await swapPurchaseCardsService(subtitle, chapter, title);
    if (result) {
      setswapDataPurchase(result);
      console.log(result);

      setLoader(false);
    } else {
      setLoader(false);
    }
  };
  return (
    <>
      {!loader ? (
        <>
          <div className="container">
            <div className="row">
              <div class="d-flex justify-content-between align-items-center">
                <h2>
                  {data.length > 0
                    ? data?.[0].card_collection_title?.name +
                      "/" +
                      data?.[0]?.card_collection_sub_title?.name +
                      "/" +
                      data?.[0]?.chapter?.name
                    : null}
                </h2>
                {isLogin ? (
                  <div className="pt-2">
                    {/* {isSwap ? (
                    
                    ) : (
                 
                    )} */}
                    <button
                      className={`${
                        isSwap.isSale
                          ? "btn  btn-primary ms-2 my-2"
                          : "btn btn-outline-primary ms-2 my-2"
                      }`}
                      onClick={() => {
                        HandleGetPurchaseData();

                        setIsSwap({
                          isSwap: false,
                          isSale: true,
                          isAvailable: false,
                        });
                      }}
                    >
                      Purchase
                    </button>
                    <button
                      className={`${
                        isSwap.isSwap
                          ? "btn  btn-primary ms-2 my-2"
                          : "btn btn-outline-primary ms-2 my-2"
                      }`}
                      onClick={() =>
                        setIsSwap({
                          isSwap: true,
                          isSale: false,
                          isAvailable: false,
                        })
                      }
                    >
                      Swap
                    </button>
                    <button
                      className={`${
                        isSwap.isAvailable
                          ? "btn  btn-primary ms-2 my-2"
                          : "btn btn-outline-primary ms-2 my-2"
                      }`}
                      onClick={() =>
                        setIsSwap({
                          isSwap: false,
                          isSale: false,
                          isAvailable: true,
                        })
                      }
                    >
                      Available cards
                    </button>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
          {isSwap.isSale ? (
            <>
              <ForSaleActive
                data={data}
                setLoader={setLoader}
                isLogin={isLogin}
                setSingleData={setSingleData}
                singleData={singleData}
                setData={setData}
                url={url}
              />
              <ForSwapPurchaseActive
                datas={data}
                swapData={swapDataPurchase}
                collection={id}
                ispurchase={true}
              />
            </>
          ) : isSwap.isAvailable ? (
            <ForSaleActive
              data={data}
              setLoader={setLoader}
              isLogin={isLogin}
              isAvailable={true}
              setSingleData={setSingleData}
              singleData={singleData}
              setData={setData}
              url={url}
            />
          ) : (
            <ForSwapActive swapData={swapData} collection={id} />
          )}
        </>
      ) : (
        <div className="d-flex  justify-content-center align-items-center vh-100">
          <MoonLoader size={90} loading={loader} color="#333" />
        </div>
      )}
      {/*  */}
    </>
  );
};

export default SingleActiveCollection;
